/**
 * Show notifications layout on profile view
 */
import Radio from 'backbone.radio';
import BreadcrumbNavLayout from '@/views/breadcrumb_nav_layout';
import NotificationsProfileLayout from '@/views/notifications_profile_layout';
import PaginationControls from '@/views/pagination_controls';

var globalCh = Radio.channel('global');
var routerCh = Radio.channel('router');
var apiCh = Radio.channel('api');

function show_notifications_profile(primary) {
    var app_container = globalCh.request('app_layout');

    var features = globalCh.request('app_options', 'features');
    
    if (!features.notifications) {
        globalCh.request('home');
        return;
    }

    // Get a collection of notifications for primary
    const notifications = apiCh.request('notification');
    notifications.fetch();
    notifications.on('change', function() {
        notifications.sort();

    });

    var notifications_profile_layout = new NotificationsProfileLayout({
        model: primary,
        title: 'Notification Center',
        collection: notifications,
    });

    var pagination_controls = new PaginationControls({
        collection: notifications,
    });

    app_container.showChildView('container', notifications_profile_layout);

    notifications_profile_layout.showChildView('pagination_controls', pagination_controls);

    globalCh.request('show_secondary_nav', { empty: true });

    globalCh.request('show_profile_nav', { selected: 'notifications-profile' });

    routerCh.request('set_location', 'notifications', primary);

    app_container.showChildView('main_nav', new BreadcrumbNavLayout());
    globalCh.request('changeActiveAccount', primary, function () {
        globalCh.request('set_selection', {
            type: 'app',
            id: 'home'
        });
    });

}

export default show_notifications_profile;

